import api from './api';

export type VideoUnderstandingStatus = 'queued' | 'processing' | 'completed' | 'failed' | 'cancelled';

export interface ITranscriptSegment {
  start: number;
  end: number;
  text: string;
}

export interface IChapter {
  title: string;
  start: number;
  end: number;
}

export interface IHighlight {
  start: number;
  end: number;
  score: number;
  label?: string;
  reason?: string;
}

export interface IVideoUnderstandingStep {
  id: 'download' | 'transcribe' | 'analyze';
  status: 'pending' | 'processing' | 'completed' | 'failed' | 'skipped';
  startedAt?: string;
  completedAt?: string;
  error?: string;
}

export interface IVideoUnderstandingJob {
  jobId: string;
  title?: string;
  videoS3Url?: string;
  language?: string;
  status: VideoUnderstandingStatus;
  progress: number;
  currentStep: string;
  error?: string;
  steps?: IVideoUnderstandingStep[];
  transcript?: string;
  transcriptSegments: ITranscriptSegment[];
  chapters: IChapter[];
  topics: string[];
  summary?: string;
  highlights: IHighlight[];
  createdAt: string;
  updatedAt: string;
}

export interface VideoUnderstandingRequest {
  title?: string;
  videoS3Key?: string;
  videoS3Url?: string;
  language?: string;
}

const videoUnderstandingApi = {
  createJob: (data: VideoUnderstandingRequest) =>
    api.post<{ success: boolean; jobId: string; job: Partial<IVideoUnderstandingJob> }>('/video-understanding', data),

  getJobs: () =>
    api.get<{ success: boolean; jobs: Partial<IVideoUnderstandingJob>[] }>('/video-understanding'),

  getJob: (jobId: string) =>
    api.get<{ success: boolean; job: IVideoUnderstandingJob }>(`/video-understanding/${jobId}`),

  cancelJob: (jobId: string) =>
    api.delete<{ success: boolean; message: string }>(`/video-understanding/${jobId}`),
};

export default videoUnderstandingApi;
